import { DragEvent } from 'react';

import { IPanelLink } from '../../../models/dataset/DatasetRelated';
import { DRAGGABLE_EVENT_NAME } from '../MainView/PanelLinks';
import {
  DRAGGABLE_CELL_CLASS,
  DRAGGABLE_CELL_ID,
} from '../MainView/PanelLinks/styles';

import { UseDraggable } from './types';

export const useDraggable: UseDraggable = props => {
  const menuItemProps: IPanelLink = {
    label: props.label,
    ...(props.icon && { icon: props.icon }),
    category: props.category,
    displayMode: props.displayMode,
    ...(props.inParams && { inParams: props.inParams }),
    ...('action' in props && { action: props.action }),
  };

  const onDragStart = (event: DragEvent<HTMLDivElement>) => {
    event.dataTransfer.effectAllowed = 'link';
    event.dataTransfer.setData(
      `${DRAGGABLE_EVENT_NAME}/menuItemProps`,
      JSON.stringify(menuItemProps)
    );
    document
      .getElementById(DRAGGABLE_CELL_ID)
      ?.classList.add(DRAGGABLE_CELL_CLASS);
  };
  const onDragEnd = () => {
    document
      .getElementById(DRAGGABLE_CELL_ID)
      ?.classList.remove(DRAGGABLE_CELL_CLASS);
  };

  return { onDragStart, onDragEnd };
};
